export class MapUtils {
  static arrayFromValues(map) {
    const array = [];
    map.forEach((v) => {
      array.push(v);
    });
    return array;
  }
  static pushOnArrayAtEntry(map, key, newElement) {
    let has_entry = map.has(key);
    if (has_entry) {
      map.get(key).push(newElement);
    } else {
      map.set(key, [newElement]);
    }
  }
  static addToSetAtEntry(map, key, newElement) {
    let has_entry = map.has(key);
    if (has_entry) {
      map.get(key).add(newElement);
    } else {
      const set = /* @__PURE__ */ new Set();
      set.add(newElement);
      map.set(key, set);
    }
  }
  static popFromArrayAtEntry(map, key, elementToRemove) {
    let has_entry = map.has(key);
    if (has_entry) {
      const array = map.get(key);
      const index = array.indexOf(elementToRemove);
      if (index >= 0) {
        array.splice(index, 1);
      }
    }
  }
  static removeFromSetAtEntry(map, key, elementToRemove) {
    let has_entry = map.has(key);
    if (has_entry) {
      const set = map.get(key);
      set.delete(elementToRemove);
      if (set.size == 0) {
        map.delete(key);
      }
    }
  }
  static unshiftOnArrayAtEntry(map, key, newElement) {
    let has_entry = map.has(key);
    if (has_entry) {
      map.get(key).unshift(newElement);
    } else {
      map.set(key, [newElement]);
    }
  }
  static concatOnArrayAtEntry(map, key, newElements) {
    let has_entry = map.has(key);
    if (has_entry) {
      let array = map.get(key);
      for (let element of newElements) {
        array.push(element);
      }
    } else {
      map.set(key, newElements);
    }
  }
  static async forEachSync(map, callback) {
    const values = [];
    const keys = [];
    map.forEach((value, key) => {
      values.push(value);
      keys.push(key);
    });
    for (let i = 0; i < values.length; i++) {
      const key = keys[i];
      const value = values[i];
      await callback(value, key);
    }
  }
  static groupBy(array, callback) {
    const map = /* @__PURE__ */ new Map();
    array.forEach((element) => {
      const key = callback(element);
      this.pushOnArrayAtEntry(map, key, element);
    });
    return map;
  }
}
